<template>
  <vue-scroll :ops="ops" ref="vs" @handle-scroll="handleScroll">
    <div class="newsInfo">
      <div class="banner" id="d1">
        <first-Component  class="header" :class="{active:!isShowNav}"  style="position: absolute;top:0;z-index: 999;background-color: white;" :num=1 ></first-Component>

        <first-Component class="animated bounceInDown" style="position: fixed;
    z-index: 999999;
    background-color: white;animation-duration:3s;" :num=1  v-if="!isShowNav"></first-Component>
      </div>

      <div class="content">
         <p class="title wow fadeInUp">{{newsInfo.TITLE}}</p>
        <p class="time wow fadeInUp">{{newsInfo.NOTETIME}}</p>
        <span class="line wow fadeInUp"></span>
        <div class="allCon" v-html="newsInfo.CONTENT">

        </div>
        <span class="btn wow fadeInUp" @click="$router.go(-1)">back</span>
      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
  </vue-scroll>
</template>



<script>
  import footComponent from './foot'
  import firstComponent from './first'
  import  {WOW} from 'wowjs'
  import {getNewsInfo} from '../util/lang'
    export default {
        name: "newsInfo",
      data(){
          return{
            newsInfo:{},
            isShowNav:true,
            wow:'',
            ops: {
              vuescroll: {
                mode: 'native',
                sizeStrategy: 'percent',
                detectResize: true
              },
              scrollPanel: {
                speed: 300,
                scrollingX: false,
              },
              rail: {
                background: '#01a99a',
                opacity: 0.8,
                size:'2px'
              },
              bar: {
                showDelay: 500,
                background: '#0C3665',
                size: '2px',
              }
            },
          }
      },
      components:{firstComponent,footComponent},
      mounted(){
        this.wow=new WOW();
        this.wow.init()
        let id=this.$route.query.id
      this.getNewsIn(id)
      },
      methods:{  gotoTop(){
          this.$refs['vs'].scrollIntoView('#d1', 500);
        },
          getNewsIn(id){
            this.$nextTick(()=>{
              const url = `${getNewsInfo( this.$i18n.locale,id)}`
              this.$axios.get(url).then(res => {
                this.newsInfo=res.data
              })
            })
          },
        handleScroll(vertical, horizontal, nativeEvent) {
          let top=vertical.scrollTop
          if(top>0){
            this.isShowNav=false
          }else{
            this.isShowNav=true
          }
          window.pageYOffset=top
          this.wow.scrollHandler()
        },
      }
    }
</script>

<style lang="scss" scoped>
  .header{
    transition: 1s;
    &.active{
      transform: translateY(-100%);
    }
  }
.newsInfo{
  width:100%;
  .banner{
    width:100%;
    position: relative;
    height:80px;
  }
  .content{
    width:80%;
    margin: 0 auto;
    text-align: center  ;
    padding-top: 60px;
 .title{
   font-size: 28px;
 }
    .time{
      font-size: 20px;
    }
    .line{
      display: inline-block;
      width:100%;
      height:1px;
      background-color: #a1aab2;;
    }
    .allCon{
      width:100%;
      padding-bottom: 60px;
      overflow: hidden;
      line-height: 40px;
      .MsoNormal{
        line-height: 30px;
      }
      p{
        line-height: 50px;
        text-align: left;
      }
    }
    .btn{
      font-weight: bold;
      display: inline-block;
      color:#C7000C;
      padding: 8px 8%;
      font-size: 12px;
      border: 1px solid #0C3665;
      -webkit-border-radius: 60px / 50px;
      -moz-border-radius: 60px / 50px;
      border-radius: 60px / 60px;
      cursor: pointer;
      background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
      background-size: 100% 0%;
      text-transform: uppercase;
      -webkit-transition: all .5s;
      transition: all .5s;
    }
    .btn:hover{
      background-size: 100% 100%;
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newsInfo.vue